import { IntegrationSettingsValues } from "@trnsact/trnsact-shared-types";
import { IntegrationSettingsEntry, IntegrationSettingsUserLevelForm } from "../types";
import { UserProfile } from "types";

export const getUserIntegrationSettingsTableData = (
  user: UserProfile,
  integrationSettingsValues: IntegrationSettingsValues
): IntegrationSettingsUserLevelForm => ({
  userProfileId: user.id,
  fullName: user.fullName ?? "",
  title: user.title ?? "",
  email: user.email ?? "",
  integrationSettingsValuesId: integrationSettingsValues?.integrationSettingsValuesId || null,
  integrationSettingsValues: integrationSettingsValues
    ? {
        ...(integrationSettingsValues.integrationSettingsValues as unknown as IntegrationSettingsEntry),
      }
    : null,
});
